import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { AdapterService } from './adapter.service';

import { environment } from 'src/environments/environment';
const routes = {
  auth: () => 'auth'
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private apiService: ApiService, private _adapterService: AdapterService) { }

  login(model: any): Observable<any> {
    return this.apiService.post(`${routes.auth()}/login`, model);
  }

  getLoggedInUser(): any {
    let item = this._adapterService.getLocalStorageValue(environment.storageKeys.userInfo);
    return item;
  }
  logout() {
    this._adapterService.removeLocalStorageValue(environment.storageKeys.userInfo);
  }

  isLoggedIn() {
    let item = this._adapterService.getLocalStorageValue(environment.storageKeys.userInfo);
    return item !== null;
  }
}
